import { Box, Flex, Text } from '@chakra-ui/react';
import Button from '~/components/Button';
import { ManagerShortType } from '~/types';

interface Props {
  id: string;
  manager: ManagerShortType;
  agencyEntityName?: string;
  onConfirm: (
    id: string,
    manager: ManagerShortType,
    newAgencyName?: string,
  ) => void;
  onReject: (id: string) => void;
}

export const ManagedCreatorInvitationListItem: React.FC<Props> = ({
  id,
  manager,
  agencyEntityName,
  onConfirm,
  onReject,
}) => {
  // agencyEntityName vs agencyName => agencyEntityName is the new agency entity name
  // agencyName is the old manager agency name before the creation of the new agency entity
  // retrocompatibility >> @TODO: remove agencyName when FOAM-1349 is done from line 24 and 43
  const { agencyName = '', name = '' } = manager;

  return (
    <Box
      width="100%"
      maxWidth="432px"
      padding={6}
      borderColor="primary.200"
      borderRadius="12px"
      borderWidth={1}
      borderStyle="solid"
      boxShadow="generic"
      background="white"
      pointerEvents="all"
    >
      <Text
        fontSize="xl"
        fontWeight={500}
        marginBottom={8}
      >{`${name} has invited you to connect to the ${
        agencyEntityName || agencyName
      } account`}</Text>

      <Flex justifyContent="space-between">
        <Button
          onClick={() => onReject(id)}
          variant="link"
          color="primary.500"
          fontSize="md"
          fontWeight="medium"
        >
          Reject
        </Button>

        <Button
          colorScheme="secondary"
          fontSize="md"
          fontWeight={500}
          onClick={() => onConfirm(id, manager, agencyEntityName)}
        >
          Accept Invite
        </Button>
      </Flex>
    </Box>
  );
};
